<!-- secondary nav -->
<div class="secondary_nav without_top_omne_bar pd-0 with-left-sidenav">
    <div class="custom_container">
       <div class="secondary_nav_items">
          <div [ngClass]="consltantListTabClass" #myDivConslList class="sn_item gen-tab" data-tab="one" (click)="RedirectConsultantList()">
             <div class="tab_text">
                <!-- <img src="../assets/images/icons/ic-documents.svg" alt="ic-send-offer" /> -->
                <i class="fa-solid fa-file-lines font-16"></i>
                Consultant List
             </div>
             <!-- <span>7</span> -->
          </div>
          <div [ngClass]="takeActionTabClass" #myDivTakeAction class="sn_item gen-tab" data-tab="two" (click)="RedirectTakeAction()">
             <div class="tab_text">
                <!-- <img src="../assets/images/icons/ic-documents.svg" alt="ic-send-offer" /> -->
                <i class="fa-solid fa-file-signature font-16"></i>
                Take Action
             </div>
              <span>{{takeActionPagePendingDocCount}}</span> 
          </div>
          <div [ngClass]="viewCompletedDocsTabClass" #myDivViewComDocs class="sn_item gen-tab" data-tab="thr" (click)="RedirectViewDocs()">
             <div class="tab_text">
                <!-- <img src="../assets/images/icons/ic-completed-docs.svg" alt="ic-view-sent-docs-grey" /> -->
                <i class="fa-solid fa-file-circle-check font-16"></i>
                View Completed Documents
             </div>
             <span>{{ViewComeletedPageDocsCount}}</span>
          </div>
          <div [ngClass]="infoDocsTabClass" #myDivInfo class="sn_item gen-tab" data-tab="fou" (click)="RedirectInfoDocs()">
             <div class="tab_text">
                <!-- <img src="../assets/images/icons/ic-completed-docs.svg" alt="ic-view-sent-docs-grey" /> -->
                <i class="fa-solid fa-file-circle-info font-16"></i>
                Information Documents
             </div>
          </div>
       </div>
    </div>
 </div>
 <!-- secondary nav -->
